import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArFulfillmentEventsCreatedNotifyApproversProps extends BaseTemplateProps {
  request: {
    name: string
  }
  createdBy: {
    name: string
  }
}

export const ArFulfillmentEventsCreatedNotifyApprovers: TemplateDefinition<ArFulfillmentEventsCreatedNotifyApproversProps> =
  {
    renderParams: (props: ArFulfillmentEventsCreatedNotifyApproversProps) => ({
      messageKey: 'notificationsDomain.templates.arFulfillmentEventsCreatedNotifyApprovers',
      values: {
        eventName: props?.request?.name,
        createdBy: props?.createdBy?.name,
      },
    }),
    getLink: (props: ArFulfillmentEventsCreatedNotifyApproversProps): string => {
      if (!props) return ''
      return '/app/admin/approvals-management/approval-requests-search?tool=fulfillment_events'
    },
  }
